import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import heroImg from "../assests/images/2204_w037_n003_308b_p1_308.jpg";

const HeroSection = () => {
  return (
    <section className="relative flex min-h-[calc(100vh-72px)] items-center overflow-hidden p-0 text-white max-md:min-h-[calc(100svh-72px)]">
      <div className="absolute inset-0 z-0" aria-hidden="true">
        <img
          src={heroImg}
          alt=""
          className="h-full w-full object-cover object-center animate-ken-burns"
        />
        <div className="absolute inset-0 bg-[linear-gradient(105deg,rgba(5,28,20,0.92)_0%,rgba(5,28,20,0.78)_42%,rgba(5,28,20,0.35)_100%),linear-gradient(180deg,rgba(5,28,20,0.2)_0%,rgba(5,28,20,0.55)_100%)]" />
        <div className="pointer-events-none absolute right-[8%] top-[12%] h-[420px] w-[420px] animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.35),transparent_68%)]" />
      </div>

      <Container>
        <div className="relative z-[1] w-full max-w-[720px] py-14 md:py-16">
          <h1 className="mb-4 animate-fade-up font-display text-[clamp(2.8rem,7vw,4.6rem)] font-extrabold leading-none tracking-tight text-white">
            Ez<span className="text-brand-teal">Shiksha</span>
          </h1>
          <p className="mb-3.5 max-w-[28ch] animate-fade-up-1 font-display text-[clamp(1.35rem,2.6vw,1.85rem)] font-medium leading-snug text-[#f3fffb]">
            Ascend academically with tools built for real study sessions.
          </p>
          <p className="mb-7 max-w-[42ch] animate-fade-up-2 text-[1.05rem] leading-relaxed text-white/90">
            Instant math help, concise notes, grammar fixes, and text from images —
            without the busywork.
          </p>
          <div className="flex flex-wrap gap-3.5 animate-fade-up-3 max-md:flex-col">
            <Link
              to="/divein"
              className="inline-flex items-center justify-center rounded-full bg-brand-teal px-6 py-3.5 font-display text-[0.98rem] font-semibold text-white no-underline transition hover:-translate-y-0.5 hover:bg-brand-teal-dark max-md:w-full"
            >
              Dive In
            </Link>
            <a
              href="#tools"
              className="inline-flex items-center justify-center rounded-full border-[1.5px] border-white/45 px-6 py-3.5 font-display text-[0.98rem] font-semibold text-white no-underline transition hover:-translate-y-0.5 hover:border-white max-md:w-full"
            >
              See tools
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HeroSection;
